import React from 'react';
import { Gift } from 'lucide-react';

interface RewardsBalanceProps {
  points: number;
}

export function RewardsBalance({ points }: RewardsBalanceProps) {
  return (
    <div className="flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-lg">
      <Gift className="w-5 h-5" />
      <div>
        <div className="text-sm font-medium">{points.toLocaleString()}</div>
        <div className="text-xs">Points Available</div>
      </div>
    </div>
  );
}